const defaultState = {
    currentSchedule: null,
    confirmed: false,
    specialists: [],
	salons: [],
	period: null,
	slots: [],
	underfilledSlots: {},
    isAltSchedule: null
}

const SET_CURRENT_SCHEDULE = "SET_CURRENT_SCHEDULE"
const SET_CONFIRMED = "SET_CONFIRMED"
const SET_SPECIALISTS = "SET_SPECIALISTS"
const SET_SALONS = "SET_SALONS"
const SET_PERIOD = "SET_PERIOD"
const SET_SLOTS = "SET_SLOTS"
const SET_UNDERFILLED_SLOTS = "SET_UNDERFILLED_SLOTS"
const SET_IS_ALT_SCHEDULE = "SET_IS_ALT_SCHEDULE"

export const scheduleReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CURRENT_SCHEDULE:
            return {...state, currentSchedule: action.payload}
        case SET_CONFIRMED:
            return {...state, confirmed: action.payload}
        case SET_SPECIALISTS:
            return {...state, specialists: action.payload}
		case SET_SALONS:
			return {...state, salons: action.payload}
		case SET_PERIOD:
			return {...state, period: action.payload}
		case SET_SLOTS:
			return {...state, slots: action.payload}
        case SET_UNDERFILLED_SLOTS:
            return { ...state, underfilledSlots: action.payload }
        case SET_IS_ALT_SCHEDULE:
            return { ...state, isAltSchedule: action.payload }

        default:
            return state
    }
}

export const setCurrentScheduleAction = (payload) => ({type: SET_CURRENT_SCHEDULE, payload})
export const setConfirmed = (payload) => ({type: SET_CONFIRMED, payload})
export const setSpecialistsAction = (payload) => ({type: SET_SPECIALISTS, payload})
export const setSalonsAction = (payload) => ({type: SET_SALONS, payload})
export const setPeriodAction = (payload) => ({type: SET_PERIOD, payload})
export const setSlotsAction = (payload) => ({type: SET_SLOTS, payload})
export const setUnderfilledSlotsAction = (payload) => ({type: SET_UNDERFILLED_SLOTS, payload})
export const setIsAltScheduleAction = (payload) => ({type: SET_IS_ALT_SCHEDULE, payload})